import $ from '../../../../../src/Resources/core/jsx/utils/jquery-global';

import Widgets from 'js-widget-hooks';

function reloadImageMaps() {
  $('img[usemap]').rwdImageMaps();
}
$(document).ready(function (e) {
  $('img[usemap]').rwdImageMaps();

  $('area').on('click', function () {
    // alert($(this).attr('data-content') + ' clicked');
  });
});
$(document).ready(function () {
  var toTop = $('.to-top');
  toTop.on('click', function () {
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    });
  });

  // $("#fullscreen").click(function() {
  //     $(".refugetree-section").toggleClass("full_screen");
  //     reloadImageMaps();
  // });

  // Variable to store footer's original position and visibility state
  var footerOriginalPosition = null;
  var footerOriginalDisplay = null;

  function photoSrc() {
    var file = $('.refugetree-section').hasClass('full_screen')
      ? 'refuge-tree-w2000-lossy.webp'
      : 'refuge-tree-w1200-lossy_v2.webp';
    return '/mahamudra-holders/img/refuge-tree/mh5/' + file;
  }

  function checkHashForFullscreen() {
    if (window.location.hash === '#full' || window.location.hash === '#full') {
      $('.refugetree-section').addClass('full_screen');
      hideFooter();
    } else {
      $('.refugetree-section').removeClass('full_screen');
      showFooter();
    }
    // Keep the photo variant in sync when the schema switch is off.
    var $switch = $('#full_image');
    if ($switch.length && !$switch.is(':checked')) {
      $('#mapping_img').attr('src', photoSrc());
    }
  }

  function hideFooter() {
    var footer = $('footer');
    if (footer.length > 0) {
      // Store original position and display state before hiding
      if (footerOriginalPosition === null) {
        footerOriginalPosition = footer.css('position');
        footerOriginalDisplay = footer.css('display');
      }
      footer.hide();
    }
  }

  function showFooter() {
    var footer = $('footer');
    if (footer.length > 0 && footerOriginalPosition !== null) {
      // Restore footer to its original position and visibility
      footer.css('position', footerOriginalPosition);
      footer.css('display', footerOriginalDisplay);
      footer.show();
    }
  }

  // Check hash on page load
  checkHashForFullscreen();

  // Check hash on hash change
  $(window).on('hashchange', function () {
    checkHashForFullscreen();
  });

  // Toggle fullscreen class on button click
  $('#fullscreen').click(function () {
    $('.refugetree-section').toggleClass('full_screen');
    if ($('.refugetree-section').hasClass('full_screen')) {
      window.location.hash = 'full';
      hideFooter();
    } else {
      window.location.hash = '';
      showFooter();
    }
    reloadImageMaps(); // Assuming this function is defined elsewhere
  });

  $('area').click(function () {
    $('.refugetree-body').hide();
    /*var contentId = $(this).data('content');
                if (!contentId) {
                    console.error("Data-content is empty!");
                    return;
                }

                // Convert spaces to hyphens
                let targetId = contentId.replace(/ /g, '-');*/

    // Use data-target (the clean slug-able name) to find the panel id.
    // data-content is only the display name (for tooltips) and may contain
    // special characters that would not match the panel id.
    let rawContent = $(this).data('target') || $(this).data('content');

    if (rawContent) {
      // 2. Map of special characters
      const charMap = {
        'ä': 'ae',
        'ö': 'oe',
        'ü': 'ue',
        'Ä': 'ae',
        'Ö': 'oe',
        'Ü': 'ue',
        'ß': 'ss',
      };

      // 3. Perform the transformation
      let targetId = rawContent
        .toLowerCase() // Small letters
        .split('') // Break into characters
        .map((char) => charMap[char] || char) // Swap ö for oe, etc.
        .join('') // Put back together
        .trim() // Remove outside spaces
        .replace(/[^a-z0-9]+/g, '-') // Swap spaces & special chars for hyphens
        .replace(/^-+|-+$/g, ''); // Trim leading/trailing hyphens

      console.log('Looking for ID: ' + targetId);
      //var contentId = $(this).data('content').replace(/ /g, '-');
      //$('#' + contentId).show();
      let $targetDiv = $('#' + $.escapeSelector(targetId));
      if ($targetDiv.length > 0) {
        $targetDiv.show();

        // Warm the "Read more" target while the user reads the bio.
        let readMoreHref = $targetDiv.find('.btn[data-href]').attr('data-href');
        if (
          readMoreHref &&
          !$('link[rel="prefetch"][href="' + readMoreHref + '"]').length
        ) {
          $('<link rel="prefetch" href="' + readMoreHref + '">').appendTo(
            'head',
          );
        }
      } else {
        console.error("Could not find a <div> with id='" + targetId + "'");
      }
    }
  });
  // Inject a close button into each refuge-tree popup body if it does not already have one.
  $('.refugetree-body').each(function () {
    if ($(this).find('> span.close').length === 0) {
      $(this).prepend(
        '<span class="close" tabindex="0" role="button" aria-label="Close"><i class="fas fa-times"></i></span>',
      );
    }
  });
  $('span.close').click(function () {
    $('.refugetree-body').hide();
  });
  $('span.close').on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $('.refugetree-body').hide();
    }
  });
  // Default to the schema/silhouette view (switch ON by default)
  if ($('#full_image').is(':checked')) {
    $('#mapping_img').attr(
      'src',
      '/mahamudra-holders/img/refuge-tree/mh4/schema-refuge-tree.jpg',
    );
    $('.image-map-inner').addClass('teachers-silhouette');
  }

  $('#full_image').change(function () {
    if ($(this).is(':checked')) {
      $('#mapping_img').attr(
        'src',
        '/mahamudra-holders/img/refuge-tree/mh4/schema-refuge-tree.jpg',
      );
      $('.image-map-inner').toggleClass('teachers-silhouette');
    } else {
      $('#mapping_img').attr('src', photoSrc());
      $('.image-map-inner').toggleClass('teachers-silhouette');
    }
  });
});

$(document).ready(function () {
  $('area[class^="lineageholder-"]').on('mouseenter', function (e) {
    let tooltipText = $(this).attr('data-content').replace(/-/g, ' ');
    $('#tooltip').text(tooltipText).show();

    // Highlight corresponding circle
    let index = $(this).attr('class').split('-')[1];
    $(`.highlight-${index}`).addClass('active');
  });

  $('area[class^="lineageholder-"]').on('mousemove', function (e) {
    $('#tooltip').css({
      top: e.pageY + 15 + 'px',
      left: e.pageX + 15 + 'px',
    });
  });

  $('area[class^="lineageholder-"]').on('mouseleave', function () {
    $('#tooltip').hide();

    // Remove highlight from circle
    $('.highlight').removeClass('active');
  });

  $('area').on('mouseover', function () {
    var coords = $(this).attr('coords').split(',');
    var x = parseInt(coords[0]);
    var y = parseInt(coords[1]);
    var radius = parseInt(coords[2]);

    // Update the SVG circle dynamically
    $('#highlight-circle').attr({
      'cx': x,
      'cy': y,
      'r': radius,
      'stroke': '#C90033', // Change stroke color on hover
    });

    $('.image-map-inner.teachers-silhouette #highlight-circle').attr({
      'stroke': 'transparent',
    });

    // Show the tooltip with content from data-content
    $('#tooltip').css({
      'left': x + 10 + 'px',
      'top': y + 10 + 'px',
    }).text($(this).data('content')).show();
  });

  // Hide circle and tooltip on mouseout
  $('area').on('mouseout', function () {
    $('#highlight-circle').attr('stroke', 'transparent');
    $('#tooltip').hide();
  });
});

(function (a) {
  a.fn.rwdImageMaps = function () {
    var c = this;
    var b = function () {
      c.each(function () {
        if (typeof (a(this).attr('usemap')) == 'undefined') return;
        var e = this, d = a(e);
        a('<img />').on('load', function () {
          var g = 'width', m = 'height', n = d.attr(g), j = d.attr(m);
          if (!n || !j) {
            var o = new Image();
            o.src = d.attr('src');
            if (!n) n = o.width;
            if (!j) j = o.height;
          }
          var f = d.width() / 100,
            k = d.height() / 100,
            i = d.attr('usemap').replace('#', ''),
            l = 'coords';
          a('map[name="' + i + '"]').find('area').each(function () {
            var r = a(this);
            if (!r.data(l)) r.data(l, r.attr(l));
            var q = r.data(l).split(','), p = new Array(q.length);
            for (var h = 0; h < p.length; ++h) {
              if (h % 2 === 0) p[h] = parseInt(((q[h] / n) * 100) * f);
              else p[h] = parseInt(((q[h] / j) * 100) * k);
            }
            r.attr(l, p.toString());
          });
        }).attr('src', d.attr('src'));
      });
    };
    a(window).resize(b).trigger('resize');
    return this;
  };
})(jQuery);
